import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import ToggleInput from 'src/elements/inputs/ToggleInput';
import { PricingDisplayMode } from 'src/elements/pricing/PricingBanner';
import Heading from 'src/elements/typography/heading';
import Paragraph from 'src/elements/typography/paragraph';
import useOnMobile from 'src/hooks/useOnMobile';
import { PricingBannersContainer, ToggleWrapper } from 'src/styles/pages/pricing-page.styles';
import PricingPlanBanners from './PricingPlanBanners';
import { PricingPlansContainer, PricingPlansContent } from './PricingPlansDetailsBanner.styles';

interface PricingPlansDetailsBannerProps {
  activePriceMode: PricingDisplayMode;
  setActivePriceMode: (newValue: PricingDisplayMode) => void;
}

const pricingToggleOptions = [
  {
    label: 'Annual',
    value: 'annual'
  },
  {
    label: 'Monthly',
    value: 'monthly'
  }
];

const PricingPlansDetailsBanner = ({ activePriceMode, setActivePriceMode }: PricingPlansDetailsBannerProps): JSX.Element => {
  const isMobile = useOnMobile(800);

  const pricingPlans: any = useStaticQuery(graphql`{
    pricing: contentfulPricing(contentful_id: {eq: "3MVlrgM0V8QHZaywYDSrrU"}) {
      pricingItems {
        id
        title
        subtitle
        description {
          description
        }
        annualPrice
        monthlyPriceDescription
        monthlyPrice
        annualPriceDescription
        featured
        cta {
          ...ButtonContent
        }
        featuresTitle
        featuresList
        disclaimer {
          disclaimer
        }
      }
    }
  }
  `)

  return (
    <PricingPlansContainer>
      <PricingPlansContent>
        <Heading
          text="Try Mighty Networks for free"
          size="3.375rem"
          sizeSm="1.875rem"
          align="center"
        />
        <Paragraph
          text="Start your 14-day free trial, and pick a plan later. No credit card required."
          size="1.75rem"
          sizeSm="1.1rem"
          align="center"
          weight="light"
        />
        {
          !isMobile && (
            <PricingBannersContainer>
              <PricingPlanBanners pricingPlans={pricingPlans.pricing.pricingItems} pricingDisplayMode={activePriceMode} />
            </PricingBannersContainer>
          )
        }
        <ToggleWrapper>
          <ToggleInput
            options={pricingToggleOptions}
            onChange={(newValue) => setActivePriceMode(newValue as PricingDisplayMode)}
          />
          <Paragraph text="2 months free with annual purchase" size="14px" align="center" weight="light" />
        </ToggleWrapper>
      </PricingPlansContent>
    </PricingPlansContainer>
  )
}

export default PricingPlansDetailsBanner;
